import * as Scrivito from "scrivito";
import { getBasePath, getCategoryLanguage } from "./filterByTenant";

const getHomepageUsingTenantsJSON = () => {
  // if Obj has no path, then look for its Homepage basing on tenants.json and URL address
  const basePath = getBasePath();

  const defaultLocale = getCategoryLanguage();
  const homepagePath = `${basePath}/${defaultLocale}`;
  return (
    Scrivito.Obj.getByPath(`${homepagePath}`) ??
    Scrivito.Obj.getByPath(basePath as string)
  );
};

const homePageConfId = "ffb29c76cc57918b";
const homePageSalesId = "715668dd9192d34e";

let cachedHomepage: Scrivito.Obj;

export const getHomepage = () => {
  if (cachedHomepage) return cachedHomepage;
  const isSameProject =
    globalThis?.location?.hostname.startsWith("sales") ||
    process?.env?.REACT_APP_IS_SAME === "true";

  const homePage = Scrivito.Obj.get(
    isSameProject ? homePageSalesId : homePageConfId,
  );

  if (homePage) {
    cachedHomepage = homePage;
    return homePage;
  }

  const currentPage = Scrivito.currentPage();

  if (!currentPage) {
    return;
  }
  if (currentPage.objClass() === "Homepage") {
    return Scrivito.Obj.getByPath(currentPage.path() as string);
  }
  if (
    !currentPage.path() ||
    currentPage.objClass() === "Root" ||
    currentPage.objClass() === "Website"
  ) {
    return getHomepageUsingTenantsJSON();
  }
  const ancestors = currentPage.ancestors();

  const searchedHomePageType = isSameProject ? "HomepageSame" : "Homepage";

  const homepage = ancestors
    .map((anc) => ({
      path: anc && anc.path(),
      objClass: anc && anc.objClass(),
    }))
    .filter((page) => page?.objClass === searchedHomePageType)[0];
  // if page has no homepage Obj in its ancestors use one from tenantsJSON, else use homepage path

  return !homepage
    ? getHomepageUsingTenantsJSON()
    : (Scrivito.Obj.getByPath(homepage.path as string) ??
        getHomepageUsingTenantsJSON());
};
